import { render, staticRenderFns } from "./TitleList.vue?vue&type=template&id=1b06eaf4&scoped=true&"
import script from "./TitleList.vue?vue&type=script&lang=js&"
export * from "./TitleList.vue?vue&type=script&lang=js&"
import style0 from "./TitleList.vue?vue&type=style&index=0&id=1b06eaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06eaf4",
  null
  
)

export default component.exports